module.exports = __webpack_public_path__ + "img/te-mision1.9f568597.jpg";